<template lang="pug">
  v-container(fluid)
    h2.text-center {{ translations.title }}

    //- v-divider
    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="_id"
        )
          template(v-slot:item="{ item, expand, isExpanded }")
            tr
              td
                span.fantasy__block-width--8 {{ item.name }}
              td {{ item.code }}
              td {{ item.connector }}
              td
                span(v-for="(item,i) in item.jurisdiction", :key="'jurisdiction'+i") {{ item.value }} 
              td
                BaseConfirmDialog(v-if="hasPermission('views.operators.toggleOperator')" @confirm="toggleState(item._id)" v-bind="translations.confirmationDialog.status")
                  template(v-slot="{ on }")
                    v-btn(v-on="on", :color="getColor(item.disabled)", :loading="loadingToggleOperator" dark rounded) {{ getStatus(item.disabled) }}
                v-chip(v-else :color="getColor(item.disabled)" text-color="white") {{ getStatus(item.disabled) }}
              td
                v-btn(@click="expand(!isExpanded)" color="primary" text)
                  span {{ translations.dialog.providers.expandButton }} 
                  v-icon(v-if="isShowed(expanded, item)") mdi-chevron-up
                  v-icon(v-else) mdi-chevron-down
              td
                BaseDetailDialog(:button="translations.dialog.details.button", :title="translations.dialog.details.title + item.name")
                  BaseDefinitionList(:items="getDetailsOperator(item)" keysAlign="text-left text-sm-right" valuesAlign="4/8")
              td
                BaseDetailDialog(:button="translations.dialog.iplist.button", :title="translations.dialog.iplist.title + item.name")
                  OperatorIpList(:ips="item.ips", :operatorId="item._id", :translations="translationsOperatorIpList")
              td(v-if="hasPermission('views.operators.editOperator')")
                BaseDialog(type="edit", :title="translationsForm.title.edit + item.name" v-slot="{close, opened}")
                  OperatorEdit(@successEdit="updateOperators(opened,close)", :clearForm="opened", :competitions="competitionListAll", :operator="item", :connectors="connectors", :jurisdictions="jurisdictions", :translations="translationsForm", :accountManagerList="accountManagerListAll")
          template(v-slot:expanded-item="{ item, headers }")
            tr
              td(:colspan="headers.length" class="grey lighten-4")
                v-card.elevation-1.my-4.pa-0
                  v-simple-table(v-if="item.providers.length")
                    template(v-slot:default)
                      tbody
                        tr(v-for="provider in item.providers", :key="provider._id")
                          td {{ provider.p ? provider.p.n : 'falta' }}
                          td
                            OperatorProviderEditDialog(
                              :title="`${ translationsOperatorProviderForm.title.operator + item.name + translationsOperatorProviderForm.title.provider + (provider.p ? provider.p.n : 'FALTA')}`"
                              :button="translationsOperatorProviderForm.button.details"
                              :operator="item._id"
                              :provider="provider"
                              @successEdit="getOperators"
                              :translations="translationsOperatorProviderForm")
                          td
                            BaseConfirmDialog(v-if="hasPermission('views.operators.editOperator')" @confirm="toggleOperatorProvider(item._id, provider.p._id)" v-bind="translations.confirmationDialog.status")
                              template(v-slot="{ on }")
                                v-btn(v-on="on", :color="getColor(provider.d)" dark rounded) {{ getStatus(provider.d) }}
                  p.text-center.my-0.py-4(v-else) {{ translations.emptyProviders }}
                  p.text-center.my-0.py-4(v-if="filterProviders(providerListAll, item.providers).length > 0")
                    BaseDialog(:button="translationsOperatorProviderForm.button.openadd", :title="translationsOperatorProviderForm.title.operator + item.name + translationsOperatorProviderForm.title.create" v-slot="{close, opened}")
                      OperatorProviderCreate(@successCreate="updateOperators(opened,close)", :clearForm="opened", :translations="translationsOperatorProviderForm", :operator="item._id", :providers="filterProviders(providerListAll, item.providers)")
        BaseDialog(v-if="hasPermission('views.operators.createOperator')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
          OperatorCreate(@successCreate="updateOperators(opened,close)", :clearForm="opened", :competitions="competitionListAll", :connectors="connectors", :jurisdictions="jurisdictions", :translations="translationsForm", :accountManagerList="accountManagerListAll")
</template>

<script>

  import OperatorProviderEditDialog from "./components/OperatorProviderEditDialog";
  import OperatorIpList from "@/components/lists/OperatorIpList";
  import OperatorCreate from './forms/OperatorCreate';
  import OperatorEdit from './forms/OperatorEdit';
  import OperatorProviderCreate from './forms/OperatorProviderCreate';

  import { connectors, jurisdictions } from "@/store/variablesGlobals";

  export default {
    name: "OperatorsIndex",
    components: {
      OperatorProviderEditDialog,
      OperatorIpList,
      OperatorCreate,
      OperatorEdit,
      OperatorProviderCreate,
    },
    data:() =>({
      expanded: [],
      connectors: connectors,
      jurisdictions: jurisdictions,
    }),
    computed: {
      translations(){
        return this.$t("views.operatorsIndex");
      },
      translationsForm(){
        return this.$t("forms.operator");
      },
      translationsOperatorProviderForm(){
        return this.$t("forms.operatorProvider");
      },
      translationsOperatorIpList(){
        return this.$t("forms.operatorIpList");
      },
      headers(){
        let headers = [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.code,
            value: 'code'
          },
          {
            text: this.translations.tableHeadText.connector,
            value: 'connector'
          },
          {
            text: this.translations.tableHeadText.jurisdiction,
            value: 'jurisdiction'
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status'
          },
          {
            text: '',
            value: 'resume',
            sortable: false
          },
          {
            text: '',
            value: 'iplist',
            sortable: false
          },
          {
            text: '',
            value: 'stats',
            sortable: false
          },
        ];
        if(this.hasPermission('views.operators.editOperator')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        return  this.operatorsListAll.map(operator => {
          const jurisdictionTmp = typeof operator.j === 'string' ? [operator.j] : operator.j;
          const jurisdictionsSelected = jurisdictions.filter( item => (jurisdictionTmp || []).includes(item.value) );
          return {
            _id: operator._id,
            name: operator.n,
            code: operator.c,
            competition: operator.f != undefined && operator.f.cl != undefined? operator.f.cl : [],
            connector: operator.con,
            connectorId: operator.cid != undefined ? operator.cid : '',
            connectorKey: operator.ckey != undefined ? operator.ckey : '',
            jurisdiction: jurisdictionsSelected,
            status: operator.__v,
            ips: operator.ips != undefined ? operator.ips : [],
            key: operator.k,
            casinoApi: operator.capi != undefined ? operator.capi : '',
            sportsApi: operator.sapi != undefined ? operator.sapi : '',
            bonusApi: operator.bapi != undefined ? operator.bapi : '',
            providers: operator.p,
            disabled: operator.d == true ? true : false,
            url: {
              lobby: operator.url != undefined ? operator.url.l : '',
              cashier: operator.url != undefined ? operator.url.c : '',
              virtualsports: operator.url != undefined ? operator.url.vs : '',
              sportsbook: operator.url != undefined ? operator.url.sb :'',
            },
            invoice: {
              name: operator.inv != undefined ? operator.inv.n : '',
              address: operator.inv != undefined ? operator.inv.a : '',
              vat: operator.inv != undefined ? operator.inv.v : '',
              tax: operator.inv != undefined ? operator.inv.t : '',
              phone: operator.inv != undefined ? operator.inv.p : '',
              email: operator.inv != undefined ? operator.inv.m : '',
            },
            cfg: {
              cl: operator.cfg != undefined && operator.cfg.cl === true,
              oi: operator.cfg != undefined && operator.cfg.oi === true,
              retail: operator.cfg != undefined ? operator.cfg.r : false,
              raf: operator.cfg != undefined && operator.cfg.raf === true,
              rafpct: operator.cfg != undefined && operator.cfg.rafpct ? operator.cfg.rafpct : '0',
            },
            sms: {
              enabled: operator.sms != undefined && operator.sms.e === true,
              origin: operator.sms != undefined && operator.sms.o ? operator.sms.o : null,
              user: operator.sms != undefined && operator.sms.u ? operator.sms.u : null,
              password: operator.sms != undefined && operator.sms.p ? operator.sms.p : null,
            },
            dialogcreate: false,
          }
        })
      },
      competitionListAll() {
        return this.$store.state.fantasy.competitions.map(competition => (
          {
            text: competition.name,
            value: competition._id
          }
        ));
      },
      operatorsListAll() {
        return this.$store.state.operators;
      },
      loadingToggleOperator(){
        return this.$store.state.statusCode.toggleOperator.loading;
      },
      stateToggleOperator(){
        return this.$store.state.statusCode.toggleOperator.state;
      },
      providerListAll(){
        return this.$store.state.providers.map(provider => ({
          text: provider.n,
          value: provider._id
        }));
      },
      accountManagerListAll(){
        return this.$store.state.accountManagers.map(user => {
          return {
            text:user.name,
            value:user.id
          }
        })
      },
    },
    watch: {
      stateToggleOperator: function(val){
        if (val == 200){
          this.getOperators();
        }
      },
    },
    created(){
      this.getOperators();
      this.$store.dispatch('getCompetitions');
      this.$store.dispatch('getProviders');
      this.$store.dispatch('getAccountManagers');
    },
    methods:{
      getColor(type){
        return type == undefined || type == false ? 'green' : 'red' ;
      },
      getStatus(type){
        return type == undefined || type == false ? this.translations.status.enabled : this.translations.status.disabled;
      },
      toggleState(operatorId){
        this.$store.dispatch('toggleOperator', operatorId);
      },
      toggleOperatorProvider(operatorId, providerId){
        this.$store.dispatch('toggleOperatorProvider', { operatorId, providerId });
      },
      getDetailsOperator(item){
        return [
          {
            key: this.translations.dialog.details.labels.name,
            value: item.name
          },
          {
            key: this.translations.dialog.details.labels.id,
            value: item.code
          },
          {
            key: this.translations.dialog.details.labels.connector,
            value: item.connector
          },
          {
            key: this.translations.dialog.details.labels.key,
            value: item.key
          },
          {
            key: this.translations.dialog.details.labels.connectorId,
            value: item.connectorId
          },
          {
            key: this.translations.dialog.details.labels.connectorKey,
            value: item.connectorKey
          },
          {
            key: this.translations.dialog.details.labels.jurisdiction,
            value: item.jurisdiction.map(jurisd=>{ return jurisd.text }),
            type: 'chip'
          },
          {
            key: this.translations.dialog.details.labels.status,
            value: item.status
          },
          {
            key: this.translations.dialog.details.labels.casinoApi,
            value: item.casinoApi
          },
          {
            key: this.translations.dialog.details.labels.sportsApi,
            value: item.sportsApi
          },
          {
            key: this.translations.dialog.details.labels.bonusApi,
            value: item.bonusApi
          },
          {
            key: this.translations.dialog.details.labels.disabled,
            value: item.disabled
          },
          {
            key: this.translations.dialog.details.labels.url.lobby,
            value: item.url.lobby
          },
          {
            key: this.translations.dialog.details.labels.url.cashier,
            value: item.url.cashier
          },
          {
            key: this.translations.dialog.details.labels.url.virtualsports,
            value: item.url.virtualsports
          },
          {
            key: this.translations.dialog.details.labels.url.sportsbook,
            value: item.url.sportsbook
          },
          {
            key: this.translations.dialog.details.labels.retail,
            value: item.retail
          },
          {
            key: this.translations.dialog.details.labels.invoice,
            value: 'invoice?'
            // value: item.invoice
          },
            // invoice: {
            //   name: operator.inv != undefined ? operator.inv.n : '',
            //   address: operator.inv != undefined ? operator.inv.a : '',
            //   vat: operator.inv != undefined ? operator.inv.v : '',
            //   tax: operator.inv != undefined ? operator.inv.t : '',
            //   phone: operator.inv != undefined ? operator.inv.p : '',
            //   email: operator.inv != undefined ? operator.inv.m : '',
            // },
          {
            key: this.translations.dialog.details.labels.cfg.cl,
            value: item.cfg.cl
          },
          {
            key: this.translations.dialog.details.labels.cfg.oi,
            value: item.cfg.oi
          },
          {
            key: this.translations.dialog.details.labels.cfg.raf,
            value: item.cfg.raf
          },
          {
            key: this.translations.dialog.details.labels.cfg.rafpct,
            value: item.cfg.rafpct
          },
          {
            key: this.translations.dialog.details.labels.sms.enabled,
            value: item.sms.enabled
          },
          {
            key: this.translations.dialog.details.labels.sms.origin,
            value: item.sms.origin
          },
          {
            key: this.translations.dialog.details.labels.sms.user,
            value: item.sms.user
          },
        ];
      },
      isShowed(expanded, item){
        if(expanded.length){
          return expanded[0]._id == item._id
        } else {
          return false
        }
      },
      getOperators(){
        this.$store.dispatch('getOperators');
      },
      updateOperators(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.getOperators();
        }
      },
      filterProviders(providerAll, providers){
        return providerAll.filter(item=>{
          return providers.find(elem=>{ return elem.p && elem.p._id == item.value }) == undefined;
        })
      },
    }
  }
</script>

<style lang="sass">
</style>